import React from 'react';
import PropTypes from 'prop-types';
import {SetupWizardStep} from 'constants/SetupWizardEnum';
import {TrayType} from 'constants/dataEnum';
import ImageSequence from './components/ImageSequence';
import './SetupWizard.scss';

function SetupWizardImage({stepName, subStepIndex, trayType}) {
  const isHVTrayInstalled = trayType === TrayType.HIGH_VOLUME_CADDY;
  const pngLocation = (imageName) => `./images/preparation-wizard/${imageName}.png`;

  const stepImages = {
    [SetupWizardStep.WELCOME_SCREEN]: [
      {
        imgPaths: isHVTrayInstalled ? ['tray-in-hv', 'tray-empty-1-hv'] : ['tray-in', 'tray-empty-1'],
        style: {height: '38vh', maxHeight: '385px'},
      },
    ],
    [SetupWizardStep.TRAY_CALIBRATION]: [{imgPaths: isHVTrayInstalled ? ['tray-empty-1-hv'] : ['tray-empty-1']}],
    [SetupWizardStep.A1_OFFSET_CALIBRATION]: [
      {
        captionsFormat: 'setupWizard.step.a1OffsetCalibration.substep1.image',
        imgPaths: ['cady-full', 'cady-corner-removed', 'cady-corner-removed-in-tray'],
      },
      {
        style: {height: '38vh'},
        gapSize: '4vw',
        hideArrow: true,
        imgPaths: ['collet-wrong', 'collet-correct'],
      },
    ],
    [SetupWizardStep.VISION_CALIBRATION]: [
      {
        style: {height: '35vh', maxHeight: '300px'},
        imgPaths: isHVTrayInstalled ? ['cady-empty-hv'] : ['cady-empty'],
      },
      {
        style: {height: '35vh', maxHeight: '300px'},
        imgPaths: isHVTrayInstalled ? ['cady-full-hv'] : ['cady-full'],
      },
      {
        style: {height: '35vh', maxHeight: '300px'},
        captionsFormat: 'setupWizard.step.visionCalibration.substep3.image',
        imgPaths: ['head-cover', 'head-cover-on-head'],
      },
      {style: {height: '30vh', maxHeight: '300px'}, imgPaths: ['head-cover']},
    ],
    [SetupWizardStep.PLATE_DEFINITION]: [
      {
        captionsFormat: 'setupWizard.step.plateDefinition.substep1.image',
        imgPaths: ['tray-empty-2', '96-well-plate-empty', '96-plate-on-tray'],
        style: {maxHeight: '35vh'},
        gapSize: '10px',
      },
      {
        imgPaths: ['instruction-one-left', 'instruction-two-right'],
        style: {height: '40vh'},
        hideArrow: true,
        gapSize: '0px',
      },
      {
        imgPaths: ['plate-summary'],
        style: {height: '500px'},
        unresponsivePadding: true,
      },
    ],
    [SetupWizardStep.PLATE_COPY_PROTOCOL]: [
      {
        captionsFormat: `setupWizard.step.plateCopyProtocol.substep1.${isHVTrayInstalled ? 'highVolume.' : ''}image`,
        imgPaths: isHVTrayInstalled
          ? ['96-well-plate-filled', '384-well-plate-empty', 'cady-full-hv']
          : ['96-well-plate-filled', '384-well-plate-empty', 'cady-full'],
        style: {height: '30vh', maxHeight: '300px'},
        hideArrow: true,
        gapSize: '10px',
      },
      {
        imgPaths: ['virtual-tray'],
        style: {height: '45vh', minHeight: '200px', maxHeight: '600px'},
      },
    ],
    [SetupWizardStep.FINISH_SCREEN]: [{imgPaths: ['instrument-fast']}],
  };

  const getImages = () => {
    const imagesWithPath = [];
    let images = stepImages[stepName];

    if (images) images = images[subStepIndex];
    else return {};

    if (!images) return {};

    images.imgPaths.forEach((imgName) => {
      imagesWithPath.push(pngLocation(imgName));
    });

    return {...images, imgPaths: imagesWithPath};
  };

  return <ImageSequence images={getImages()} />;
}

SetupWizardImage.propTypes = {
  stepName: PropTypes.string.isRequired,
  subStepIndex: PropTypes.number,
  trayType: PropTypes.oneOf(Object.values(TrayType)),
};

SetupWizardImage.defaultProps = {
  subStepIndex: 0,
  trayType: TrayType.NORMAL_CADDY,
};

export default SetupWizardImage;
